// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "foxit-UIExtension-full" + "." + "7c47eef7e5007d7e" + ".js";
};